import { useCallback, useEffect, useRef } from 'react'

const OnboardingPixelMount = ({ timeout, onMount }: { timeout?: number; onMount?: () => void }) => {
  const onMountRef = useRef(onMount)

  useEffect(() => {
    onMountRef.current = onMount
  }, [onMount])

  const handleMount = useCallback(() => {
    if (onMountRef.current) {
      onMountRef.current()
    }
  }, [])

  useEffect(() => {
    if (timeout) {
      setTimeout(handleMount, timeout)
    } else {
      handleMount()
    }
  }, [handleMount, timeout])

  return null
}

export default OnboardingPixelMount
